.container {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.25rem;
  gap: 0;
  overflow: hidden;
  border-radius: var(--glass-radius-lg, var(--glass-radius-xl));
  isolation: isolate;
  backdrop-filter: var(
    --glass-tabbar-filter,
    blur(var(--ag-tabbar-blur, var(--glass-blur-md, 24px)))
      var(--glass-filter-base)
  );
  -webkit-backdrop-filter: var(
    --glass-tabbar-filter,
    blur(var(--ag-tabbar-blur, var(--glass-blur-md, 24px)))
      var(--glass-filter-base)
  );
  transition:
    backdrop-filter var(--glass-motion-duration-fast, 150ms) ease,
    box-shadow var(--glass-motion-duration-fast, 150ms) ease;
}

.horizontal {
  flex-direction: row;
}

.vertical {
  flex-direction: column;
}

.elevated {
  box-shadow: var(
    --glass-elev-tabbar-container,
    0 12px 32px color-mix(in srgb, var(--glass-black) 18%, transparent)
  );
}

.noBackground {
  background: transparent !important;
  box-shadow: none !important;
}

.container > * {
  position: relative;
  z-index: 1;
}

.selectorBase {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  border-radius: var(--glass-radius-lg, var(--glass-radius-xl));
  pointer-events: none;
  border: 1px solid var(--glass-border-default);
  background: var(
    --glass-tabbar-selector-bg,
    linear-gradient(
      180deg,
      var(
          --glass-tabbar-selector-color-top,
          color-mix(in srgb, var(--glass-white) 28%, transparent)
        )
        0%,
      var(
          --glass-tabbar-selector-color-bottom,
          color-mix(in srgb, var(--glass-white) 16%, transparent)
        )
        100%
    )
  );
  box-shadow: var(
    --glass-elev-tabbar-selector,
    inset 0 1px 0
      var(
        --glass-border-hover,
        color-mix(in srgb, var(--glass-white) 26%, transparent)
      )
  );
  backdrop-filter: var(
    --glass-tabbar-selector-filter,
    blur(var(--ag-selector-blur, var(--glass-blur-lg, 32px)))
      var(--glass-filter-base)
  );
  -webkit-backdrop-filter: var(
    --glass-tabbar-selector-filter,
    blur(var(--ag-selector-blur, var(--glass-blur-lg, 32px)))
      var(--glass-filter-base)
  );
  transition:
    transform var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-snap, cubic-bezier(0.2, 0, 0, 1)),
    width var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-snap, cubic-bezier(0.2, 0, 0, 1)),
    height var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-snap, cubic-bezier(0.2, 0, 0, 1)),
    left var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-snap, cubic-bezier(0.2, 0, 0, 1)),
    top var(--glass-motion-duration-fast, 150ms)
      var(--glass-motion-snap, cubic-bezier(0.2, 0, 0, 1)),
    opacity var(--glass-motion-duration-fast, 150ms) ease;
  will-change: transform, width, height, left, top, opacity;
}

.selectorBase::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  background: var(
    --glass-tabbar-selector-highlight,
    radial-gradient(
      120% 60% at 20% 0%,
      var(
          --glass-tabbar-highlight-inner,
          color-mix(in srgb, var(--glass-white) 55%, transparent)
        )
        0%,
      var(--glass-tabbar-highlight-fade, transparent) 40%
    )
  );
  mix-blend-mode: overlay;
}

.selectorUnderline {
  border-radius: var(--glass-radius-pill, 9999px);
  background: var(
    --glass-color-primary,
    color-mix(in srgb, hsl(var(--glass-color-primary)) 85%, transparent)
  );
  box-shadow: none;
  backdrop-filter: var(--glass-tabbar-underline-filter, none);
  -webkit-backdrop-filter: var(--glass-tabbar-underline-filter, none);
}

.selectorUnderline::after {
  display: none;
}
